import * as type from '../../constants';

const initialState = {
    getProgramFeedbackList: [],
    viewProgramFeedback: [],
    loading: false,
    error: null,
}

export function getProgramFeedbackList(state = initialState, action) {
    switch (action.type) {
        case type.GET_PROGRAM_FEEDBACK_LIST:
            return {
                ...state,
                loading: true,
            }
        case type.GET_PROGRAM_FEEDBACK_LIST_SUCCESS:
            return {
                ...state,
                getProgramFeedbackList: action.getProgramFeedbackList,
                loading: false,
                error: null
            }
        case type.GET_PROGRAM_FEEDBACK_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}

export function viewProgramFeedback(state = initialState, action) {
    switch (action.type) {
        case type.VIEW_PROGRAM_FEEDBACK_DETAILS:
            return {
                ...state,
                loading: true,
            }
        case type.VIEW_PROGRAM_FEEDBACK_DETAILS_SUCCESS:
            return {
                ...state,
                viewProgramFeedback: action.viewProgramFeedback,
                loading: false,
                error: null
            }
        case type.VIEW_PROGRAM_FEEDBACK_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}




